import React from 'react'
import { OwnSensorV2FlowStep } from 'components/OwnSensorV2Flow/OwnSensorV2FlowStep'
import { LocationPaths } from 'location.types'
import { RouteObject } from 'react-router'
import { OwnSensorV2Flow } from 'screens/OwnSensorV2/Steps'

export const ownSensorV2: RouteObject = {
  path: LocationPaths.OwnSensorV2,
  lazy: async () => {
    const [{ OwnSensorV2Initializer }, { Layout }] = await Promise.all([
      import('components/OwnSensorV2Flow/OwnSensorV2Initializer'),
      import('components/OwnSensorV2Flow/Layout')
    ])
    return {
      element: (
        <OwnSensorV2Initializer>
          <Layout />
        </OwnSensorV2Initializer>
      )
    }
  },
  children: [
    {
      lazy: async () => ({
        Component: (await import('components/OwnSensorV2Flow/Navigation')).Navigation
      }),
      children: [
        {
          index: true,
          lazy: async () => ({ Component: (await import('screens/OwnSensorV2/Redirect')).Redirect })
        },
        ...OwnSensorV2Flow.map((step, index) => ({
          path: step.path.replace(/^\//, ''),
          element: <OwnSensorV2FlowStep stepIndex={index} />,
          handle: { index }
        }))
      ]
    }
  ]
}
